module.exports = "/cyber/_next/static/images/NYGiftNews-2b707abef717e84fbf069cb93239f915.jpg";